
var Model = require("../types/Model.js");

var DEFAULT_TIMING = "ble";

var TIMING = {
	"ble": {
		SCAN: 16 * 1000,
		PAUSE: 4 * 1000,
	},
	"bluetoothle": {
		SCAN: 16 * 1000,
		PAUSE: 16 * 1000,
	},
	OFFSET: 4 * 1000,
};

module.exports = new Model({
	name: "bluetoothscanner",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	pause: pause,
	unpause: unpause,
	stop: stop,

	clear: clear,
	schedule: schedule,
	setActive: setActive,

	_timer: null,
	_index: 0,
	_started: false,
	_TIMING: TIMING[DEFAULT_TIMING],
	_bluetoothle: false,
});

function init() {
	this._index = 0;
	this.setActive(false);
}

function uninit() {
	this.clear();
}

function triggers() {
	return {
		"start": start, // Resume scanning
		"stop": stop, // Stop scanning
	};
}

function listeners() {
	return {
		"machineindex:updated": setIndex,
		"bluetooth:loaded": handleLoaded,
	};
}

function start() {
	if (this._started) return;
	this._started = true;
	if (this._index && this._bluetoothle) {
		this.schedule(unpause, this._index * this._TIMING.OFFSET);
	} else {
		this.unpause();
	}
}

function setActive(active) {
	if (this._data == active) return;

	if (active)
		this.emit("bluetooth:trigger:scan");
	else
		this.emit("bluetooth:trigger:scan:stop");

	this.push(active);
}

function pause() {
	this.schedule(unpause, this._TIMING.PAUSE);
	this.setActive(false);
}

function unpause() {
	this.schedule(pause, this._TIMING.SCAN);
	this.setActive(true);
}

function stop() {
	this._started = false;
	this.clear();

	this.setActive(false);
}

function schedule(fn, time) {
	this.clear();
	this._timer = setTimeout(fn.bind(this), time);
}

function clear() {
	var timer = this._timer;
	if (timer) clearTimeout(timer);
	this._timer = null;
}

function setIndex(index) {
	this._index = index;
}

function handleLoaded(type) {
	if (type === "bluetoothle") {
		this._bluetoothle = true;
		this._TIMING = TIMING.bluetoothle;
	}
}
